<template>
<div style="height: 100%;width: 100%">
  <default-page v-if="scene === 1"></default-page>
  <wei-ning v-if="scene === 0"></wei-ning>
</div>
</template>

<script>
import defaultPage from './defaultPage'
import weiNing from './weiNing'
export default {
  name: 'index',
  components: {defaultPage, weiNing},
  data () {
    return {
      scene: 1
    }
  },
  created () {
    let scene = window.location.host
    console.log('scene', scene)
    if (scene === 'newjky.wecare-u.net' || scene === 'newhealth.wecare-u.net' ||
      scene === 'kangnh.com' || scene === 'bengshan.kangnh.com') { // 上海更换
      this.scene = 0
    } else {
      this.scene = 1
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/index.vue